import { Box, Grid } from '@mui/material';
import { CurrencyProvider } from '@procureai/ui-mui';
import { useFormContext } from 'react-hook-form';

import { DemandRequestDetailsInfoForm } from '../DemandRequestDetailsInfoForm/DemandRequestDetailsInfoForm';
import { DemandRequestDetailsLineItemsForm } from '../DemandRequestDetailsLineItemsForm/DemandRequestDetailsLineItemsForm';

import { DemandRequestFormData } from './DemandRequestDetailsForm.schema';

interface DemandRequestDetailsFormProps {
  referenceDisabled: boolean;
}

export const DemandRequestDetailsForm = ({ referenceDisabled }: DemandRequestDetailsFormProps) => {
  const { watch } = useFormContext<DemandRequestFormData>();

  const watchCurrency = watch('demandRequest.currency');
  return (
    <CurrencyProvider value={watchCurrency}>
      <div>
        <Grid
          container
          direction="row"
          spacing={3}
          sx={{
            justifyContent: 'flex-start',
            alignItems: 'stretch',
            alignContent: 'flex-start',
          }}
        >
          <DemandRequestDetailsInfoForm referenceDisabled={referenceDisabled} />
        </Grid>
        <Box
          sx={{
            mt: 6,
          }}
        >
          <DemandRequestDetailsLineItemsForm />
        </Box>
      </div>
    </CurrencyProvider>
  );
};
